import { tracker } from "@pjs/analytics";

try {
    if (window.self !== window.top) {
        tracker.trackEvent("Framing", "Loaded within iframe");
    }
    // tslint:disable-next-line:no-empty
} catch (e) {}
